module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "TITLE"
  }, [_vm._v("Faith Seeking Understanding")]), _vm._v(" "), _c('p', {
    staticClass: "SUBTITLE"
  }, [_vm._v("An Introduction to Christian Theology")]), _vm._v(" "), _c('p', {
    staticClass: "EDITION"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("•")]), _c('br'), _vm._v("Third Edition")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("Daniel L. Migliore")]), _vm._v(" "), _c('p', {
    staticClass: "COMPANY"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br'), _vm._v("Grand Rapids, Michigan / Cambridge, U.K.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-427557f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Migliore_Faith_Seeking_Understanding_text.vue
// module id = 57
// module chunks = 0